// A default period if not provided, e.g. for >=2025
export const DEFAULT_SKP_PERIOD = 1
